import { render, staticRenderFns } from "./relation-settings-modal.vue?vue&type=template&id=5ccf7af5&"
import script from "./relation-settings-modal.ts?vue&type=script&lang=js&"
export * from "./relation-settings-modal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports